// Port of api/fuel/app/classes/insights/collection/publishers.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Publisher from 'offline/model/publisher'

export default Segment.extend({
    name: 'publishers',
    requires: ['init'],
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        // set the limit
        var limit = detail ? 100 : 5

        var ranked = []

        // get all the base games owned
        var collectionIndex = this._data.base

        if (collectionIndex.length) {

            // get the sorted list of publishers with most games owned
            var sorted = Util.queryFast('\
                SELECT \
                    COUNT(DISTINCT p.game_id) AS collected, \
                    p.publisher_id AS publisher, \
                    group_concat(DISTINCT p.game_id ORDER BY p.game_id ASC) as i \
                FROM \
                    game_publisher p \
                WHERE \
                    p.publisher_id NOT IN(1001, 4) \
                    AND \
                    p.game_publisher_primary = 1 \
                    AND \
                    ( \
                        ( \
                            p.game_id IN (' + Util.in(this._data.versioning.games) + ') \
                            AND \
                            p.game_version_id = 0 \
                        ) \
                        OR \
                        p.game_version_id IN (' + Util.in(this._data.versioning.versions) + ') \
                    ) \
                GROUP BY \
                    p.publisher_id \
                ORDER BY \
                    COUNT(DISTINCT p.game_id) DESC, \
                    p.publisher_id ASC \
                LIMIT 0, ' + limit + ' \
            ')

            // get index of publishers
            var index = Util.pluck(sorted, 'publisher')

            // if we have results
            if (index.length) {

                var applicableGameIndex = []
                var applicableGamesGrouped = {}

                for (var si = 0; si < sorted.length; si++) {
                    var sitem = sorted[si]

                    applicableGamesGrouped[sitem.publisher] = []

                    var itemIndex = sitem.i.split(',')
                    applicableGamesGrouped[sitem.publisher] = itemIndex

                    for (var ii = 0; ii < itemIndex.length; ii++) {
                        applicableGameIndex.push(itemIndex[ii])
                    }
                }

                // get all ratings for the publisher games
                var ratings = Util.queryFast('\
                    SELECT \
                        AVG(r.rating_value) AS rating, \
                        r.game_id AS game \
                    FROM \
                        rating r \
                    WHERE \
                        r.game_id IN (' + applicableGameIndex.join(',') + ') \
                        AND \
                        r.user_id IN (' + Util.in(userIndex) + ') \
                    GROUP BY \
                        r.game_id \
                ', null, 'game')

                // get all publishers
                var details = Publisher.where([
                    ['publisher_id', 'in', index]
                ]).associated()

                // add each result to ranked list
                for (var ri = 0; ri < sorted.length; ri++) {
                    var item = sorted[ri]

                    var gameRatings = []

                    // for each publisher game
                    var pubGames = applicableGamesGrouped[item.publisher] || []
                    for (var gi = 0; gi < pubGames.length; gi++) {
                        var game_id = pubGames[gi]

                        gameRatings.push({
                            id: game_id,
                            rating: (ratings[game_id] && ratings[game_id].rating) ? parseFloat(ratings[game_id].rating) : '-'
                        })
                    }

                    gameRatings.sort(function(a, b) {
                        var ra = (a.rating === '-') ? -1 : a.rating, rb = (b.rating === '-') ? -1 : b.rating
                        return rb !== ra ? rb - ra : a.id - b.id
                    })

                    for (var ti = 0; ti < 3 && ti < gameRatings.length; ti++) {
                        this._references.games.push(gameRatings[ti].id)
                    }

                    ranked.push({
                        id: details[item.publisher] ? details[item.publisher].get_id() : item.publisher,
                        name: details[item.publisher] ? details[item.publisher].get_name() : '',
                        count: parseInt(item.collected, 10),
                        games: gameRatings.slice(0, 3)
                    })
                }

            }

        }

        return {
            publishers: ranked
        }

    }
})
